import { AxisSwitcher, Image, SpacerWrapper } from '@ahmdigital/ui';
import React from 'react';

import getImageAttributes from '../../../../../../../cms/utils/get-image-attributes';
import getLinkFromSanityTerm from '../../../../../../../utils/get-link-from-sanity-term';
import SummaryDescription from '../summary-description';

type SummaryWithImageItemProps = {
  refersToItemExplainedTerm: {};
  reverseColumn?: boolean;
};

const SummaryWithImageItem = ({ refersToItemExplainedTerm, reverseColumn }: SummaryWithImageItemProps) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { imageObject, mediaObject, slogan } = refersToItemExplainedTerm;
  const summaryImage = getImageAttributes({ height: 240, imageObject });
  const ctaObject = getLinkFromSanityTerm(refersToItemExplainedTerm);

  return (
    <SpacerWrapper variant="paddingTopSpacer2">
      <AxisSwitcher
        // @ts-expect-error - Automatic, Please fix when editing this file
        key={refersToItemExplainedTerm.id}
        reverseColumnPresentationOrder={reverseColumn}
        limit={2}
        threshold="35rem"
        space="1.5rem"
      >
        <SummaryDescription callToAction={ctaObject} mediaObject={mediaObject} slogan={slogan} />
        {summaryImage && (
          <div>
            <Image {...summaryImage} />
          </div>
        )}
      </AxisSwitcher>
    </SpacerWrapper>
  );
};

SummaryWithImageItem.defaultProps = {
  reverseColumn: false,
};

export default SummaryWithImageItem;
